<template>
  <div class="pronostics">
    <div class="row justify-content-center">
      <div class="col-xl-4 col-lg-6 col-md-8 col-12" style="margin-top:10px;">
        <div class="row justify-content-center">
          <div class="col" v-for="date in dates()" v-bind:key="date._i">
            <h5><b-badge pill variant="dark" class="d-block" :to="'/pronostics/'+date.format('YYYY-MM')" >{{ucfirst(date.format('MMMM'))}}</b-badge></h5>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-if="prognostics.length === 0">
      <b-spinner type="grow" variant="warning" style="width: 5rem; height: 5rem;" ></b-spinner>
    </div>
    <div class="row">
      <div class="col-xl-3 col-lg-4 col-md-6 col-12" style="margin-top:10px;" v-for="prognostic in prognostics" v-bind:key="prognostic.id">
        <Prognostic v-bind:prognostic="prognostic"/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Prognostic from '@/components/Prognostic.vue'
import { db } from '@/firebase.js'
import moment from 'moment'

export default {
  name: 'home',
  data: () => ({
    prognostics: [],
    dates: () => { 
      let dates = []
      for(let i=5;i>=0;i--) {
        dates.push(moment().subtract(i, 'months'))
      }
      return dates;
    },
    ucfirst(string) { return string.charAt(0).toUpperCase() + string.slice(1); }
  }),
  components: {
    Prognostic
  },/*
  firestore: {
    prognostics: db.collection('prognostics').orderBy('date', 'desc').limit(100)
  },*/
  watch: {
    '$route': {
      immediate: true,
      handler(route) {
        let period = route.params.month ? moment(route.params.month+'-01') : moment()
        this.$bind('prognostics', db.collection('prognostics').where('date', '>', period.startOf('month').unix()).where('date', '<', period.endOf('month').unix()).orderBy('date', 'desc'))
      },
    },
  }
}
</script>
